import { PickupCorporateConfigEndpoint } from "@/app/infrastructures/endpoints/horde/PickupCorporateConfigEndpoint";
import ApiService from "@/app/infrastructures/services/ApiService";
import { PickupCorporateConfigMapper } from "@/data/persistences/mappers/PickupCorporateConfigMapper";
import { PickupCorporateConfigRepositoryInterface } from "@/data/persistences/repositories/contracts/PickupCorporateConfigRepositoryInterface";
import { PickupCorporateConfig } from "@/domain/entities/PickupCorporateConfig";

export class PickupCorporateConfigApiRepository
  implements PickupCorporateConfigRepositoryInterface {
  constructor(
    private service: ApiService,
    private mapper: PickupCorporateConfigMapper,
    private endpoint: PickupCorporateConfigEndpoint
  ) {}

  public async getConfig(): Promise<PickupCorporateConfig> {
    const response = await this.service.invoke(
      "GET",
      this.endpoint.getConfig()
    );
    return this.mapper.convertFromApi(response);
  }
}
